var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _g6, _rect6, _g7, _rect7, _g8, _rect8, _g9, _rect9, _g0, _rect0, _g1, _rect1, _g10, _rect10, _g11, _g12, _g13, _g14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectionMixedLoadingTablet = function SvgCollectionMixedLoadingTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 960 552"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M44 0h206v116H44z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 44,
    y: 124,
    fill: "#1A1A1A",
    rx: 6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M266 0h206v116H266z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 266,
    y: 124,
    fill: "#1A1A1A",
    rx: 6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M488 0h206v116H488z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 488,
    y: 124,
    fill: "#1A1A1A",
    rx: 6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M710 0h206v116H710z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 710,
    y: 124,
    fill: "#1A1A1A",
    rx: 6
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M44 180h206v116H44z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 44,
    y: 304,
    fill: "#1A1A1A",
    rx: 6
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M266 180h206v116H266z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 266,
    y: 304,
    fill: "#1A1A1A",
    rx: 6
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M488 180h206v116H488z"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 488,
    y: 304,
    fill: "#1A1A1A",
    rx: 6
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M710 180h206v116H710z"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 710,
    y: 304,
    fill: "#1A1A1A",
    rx: 6
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M44 360h206v116H44z"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 44,
    y: 484,
    fill: "#1A1A1A",
    rx: 6
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M266 360h206v116H266z"
  }))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 266,
    y: 484,
    fill: "#1A1A1A",
    rx: 6
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M488 360h206v116H488z"
  }))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 488,
    y: 484,
    fill: "#1A1A1A",
    rx: 6
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M710 360h206v116H710z"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 131.489,
    height: 12,
    x: 710,
    y: 484,
    fill: "#1A1A1A",
    rx: 6
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M44 540h206v116H44z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M266 540h206v116H266z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M488 540h206v116H488z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M710 540h206v116H710z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 44,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 266,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 488,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 710,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 44,
    y: 180,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 266,
    y: 180,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 488,
    y: 180,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 710,
    y: 180,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 44,
    y: 360,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 266,
    y: 360,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 488,
    y: 360,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 710,
    y: 360,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 44,
    y: 540,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 266,
    y: 540,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 488,
    y: 540,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 116,
    x: 710,
    y: 540,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgCollectionMixedLoadingTablet;